import { useEffect, useState } from "react";
import { Reveal, Overline, PrimaryLink } from "@/components/public/ui";
import { Target, Eye, Heart, Compass, Award, Building2 } from "lucide-react";
import api from "@/lib/api";

const VALUES = [
  { icon: Award, title: "Excellence", text: "Nous visons la qualité et la fiabilité dans chaque projet livré." },
  { icon: Heart, title: "Proximité", text: "Un accompagnement humain et à l'écoute de vos besoins réels." },
  { icon: Compass, title: "Innovation", text: "Des technologies modernes au service de votre performance." },
];

export default function About() {
  const [cx, setCx] = useState({});
  const h = (k, fb) => cx[k] || fb;
  useEffect(() => { api.get("/pages/a-propos").then(({ data }) => setCx(data.sections || {})).catch(() => {}); }, []);
  return (
    <div>
      <section className="bg-gradient-to-br from-[#0F2A6B] to-[#0A1F52] relative grain">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 relative">
          <Overline><span className="text-[#4CB944]">À propos</span></Overline>
          <h1 className="mt-3 text-4xl sm:text-5xl font-bold text-white font-head max-w-3xl">Qui sommes-nous ?</h1>
          <p className="mt-5 text-lg text-slate-300 max-w-2xl">{h("intro", "VISION LOGICIELS est la branche Logiciels & Solutions Informatiques de PERFORM & CO. Nous concevons, déployons et maintenons des solutions technologiques pour accompagner votre croissance.")}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20 grid md:grid-cols-2 gap-8">
        <Reveal className="p-8 rounded-2xl bg-white border border-slate-200">
          <Target className="w-10 h-10 text-[#4CB944]" />
          <h2 className="mt-4 text-2xl font-bold text-slate-900 font-head">Notre mission</h2>
          <p className="mt-3 text-slate-600 leading-relaxed">{h("mission", "Transformer les besoins de nos clients en solutions technologiques performantes, fiables et évolutives, en Côte d'Ivoire et au-delà.")}</p>
        </Reveal>
        <Reveal delay={0.1} className="p-8 rounded-2xl bg-white border border-slate-200">
          <Eye className="w-10 h-10 text-[#4CB944]" />
          <h2 className="mt-4 text-2xl font-bold text-slate-900 font-head">Notre vision</h2>
          <p className="mt-3 text-slate-600 leading-relaxed">{h("vision", "Devenir le partenaire technologique de référence pour les entreprises et administrations africaines dans leur transformation digitale.")}</p>
        </Reveal>
      </section>

      <section className="bg-white border-y border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
          <div className="text-center max-w-2xl mx-auto mb-12"><Overline>Nos valeurs</Overline><h2 className="mt-3 text-3xl font-bold text-slate-900 font-head">Ce qui nous anime</h2></div>
          <div className="grid md:grid-cols-3 gap-6">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.1} className="p-6 rounded-2xl bg-[#FAFAF9] border border-slate-200 text-center">
                <div className="w-14 h-14 rounded-2xl bg-[#0F2A6B] grid place-items-center mx-auto mb-4"><v.icon className="w-7 h-7 text-white" /></div>
                <h3 className="text-lg font-semibold text-slate-900 font-head">{v.title}</h3>
                <p className="mt-2 text-sm text-slate-600">{v.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
        <div className="rounded-3xl bg-gradient-to-br from-[#0F2A6B] to-[#0A1F52] p-10 lg:p-14 relative grain">
          <div className="relative flex flex-col lg:flex-row items-center gap-8">
            <Building2 className="w-16 h-16 text-[#4CB944] shrink-0" />
            <div className="flex-1">
              <h2 className="text-2xl sm:text-3xl font-bold text-white font-head">VISION LOGICIELS & PERFORM & CO</h2>
              <p className="mt-3 text-slate-300 max-w-2xl">{h("group_text", "En tant que branche technologique de PERFORM & CO, VISION LOGICIELS bénéficie d'un socle solide et d'une ambition claire : accompagner le développement digital de toutes les offres du groupe.")}</p>
            </div>
            <PrimaryLink to="/contact" testid="about-contact-button" className="bg-[#4CB944] hover:bg-[#3AA033] shrink-0">Nous contacter</PrimaryLink>
          </div>
        </div>
      </section>
    </div>
  );
}
